
function some(array: any[]): boolean {
    return array.some((val) => !!val);
};
  
export default some;